module.exports = __webpack_public_path__ + "static/media/gymnastic-ball.5bcb9138.jpg";